/**
 * This function will remove trailing slashes from a string
 *
 * @author Glauber Rodger
 * @param  {string} string to have the trailing slash removed
 * @returns string
 */
export const removeTrailingSlashes = (string: string): string => string.replace(/\/+$/, '')
